export const SERVICE_CONSTANTS: any = {
    WEB_SERVICE: "svc/eazypension-web-service/v1",
    AUTH_SERVICE: "svc/eazypension-auth-service/v1",
    OTP_SERVICE: "svc/eazypension-otp-service/v1"
}

export const API_CONSTANTS: any = {
    CALCULATOR_FUND_TYPE: "api/web/calculator/fund-types",
    CALCULATOR_CALCULATE: "api/web/calculator/calculate",
    CALCULATOR_CALCULATE_PDKP: "api/web/pdkp/calculate",
    CALCULATOR_DEFAULT: "api/web/calculator/getdefault",
    SAVE_RISK_PROFILE: "api/web/risk-profile/save",
    DOWNLOAD_DOCUMENT: "api/web/documents/download",
    UPLOAD_DOCUMENT: "api/web/documents/upload/file",
    ACCOUNT: "api/web/account"
}
